import React from 'react'
import { Button, Col, Divider, Form, Input, Popconfirm, Row, Select } from 'antd'
import { FormComponent } from '../../../BaseComponent'
import ITranslationQuestion from '../../../../interfaces/ITranslationQuestion'
import ILanguage from '../../../../interfaces/ILanguage'
import QuestionTranslationAnswers from './QuestionTranslationAnswers'

type QuestionTranslationProps = {
  questionTranslation: ITranslationQuestion
  languages: ILanguage[]

  formTag: string
  answers: any[]

  loading: boolean

  onSave: (values: any) => void
  onDelete: (uuid: string, languageUuid?: string) => void
}

export default class QuestionTranslation extends FormComponent<QuestionTranslationProps> {
  render() {
    const { questionTranslation, languages, answers, formTag, loading, onSave, onDelete } = this.props

    const languagesOptions = languages.map(language => {
      return {
        label: language.name,
        value: language.uuid
      }
    })

    const values = {
      ask: questionTranslation.ask,
      language_uuid: questionTranslation.language?.uuid,
      answers: {}
    }

    // Parser translation to form
    answers.forEach(v => {
      const translation = v.translation.find(x => x.language?.uuid === questionTranslation.language?.uuid)

      values.answers[v.uuid] = {
        value: translation?.value || ''
      }
    })


    return (
      <Form
        name={`question_translation_${questionTranslation.uuid}`}
        initialValues={values}
        layout="vertical"
        onFinish={onSave}
        ref={(refs: any) => {
          if (!this.formRef) {
            this.formRef = refs
            this.forceUpdate()
          }
        }}
      >
        <Row gutter={24}>
          <Col xs={24} md={12}>
            <Form.Item
              label="Language"
              name="language_uuid"
              rules={[
                {
                  required: true,
                  message: 'Please select a language'
                }
              ]}
            >
              <Select
                placeholder="Select a language"
                options={languagesOptions}
              />
            </Form.Item>

            <Form.Item
              label="Question"
              name="ask"
              rules={[
                {
                  required: true,
                  message: 'Missing an question'
                }
              ]}
            >
              <Input.TextArea placeholder="Ask your question here" rows={4} />
            </Form.Item>
          </Col>

          <Col xs={24} md={12}>
            {
              formTag === 'SELECT' || formTag === 'RADIO' || formTag === 'CHECKBOX' ? (
                this.formRef ? <QuestionTranslationAnswers answers={answers} /> : null
              ) : null
            }
          </Col>
        </Row>

        <Divider />

        <Form.Item style={{marginTop: 32}}>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            size="large"
            block
          >
            Save
          </Button>
        </Form.Item>

        <Form.Item style={{marginTop: 10}}>
          <Popconfirm
            title="Are you sure to delete this translation?"
            onConfirm={() => onDelete(questionTranslation.uuid, questionTranslation.language?.uuid)}
            okText="Yes"
            cancelText="No"
          >
            <Button
              type="dashed"
              htmlType="submit"
              loading={loading}
              size="large"
              block
            >
              Remove Translation
            </Button>
          </Popconfirm>
        </Form.Item>
      </Form>
    )
  }
}
